<template>
  <div>
    <h2>Winemaking Notes<span v-if="var_id"> ({{ varieties[var_id] }})</span>:</h2>
    <table v-if="!var_id">
      <tr>
        <th>Actions</th>
        <th>Variety</th>
      </tr>
      <tr v-for="(variety, index) in varieties">
        <td>
          <router-link :to="`/winemaking/${index}`" class="menu-item">
            <button class="red-button">Edit</button>
          </router-link>
        </td>
        <td>{{ variety }}</td>
      </tr>
    </table>
    <div v-if="var_id">
      <button class="red-button" @click="save()">Save All {{ varieties[var_id] }} Notes</button>
      <br /><br />
      <table style="width: 100%;">
        <tr>
          <th style="width: 5%">Skin Level</th>
          <th style="width: 5%">Seed Level</th>
          <th>Aims</th>
          <th>Suggestions</th>
          <th>References</th>
        </tr>
        <tr v-for="note in notes">
          <td>
            <div :class="'tannin-cell ' + note.skin">{{ note.skin }}</div>
          </td>
          <td>
            <div :class="'tannin-cell ' + note.seed">{{ note.seed }}</div>
          </td>
          <td><textarea v-model="note.aim"></textarea></td>
          <td><textarea v-model="note.suggestion"></textarea></td>
          <td><textarea v-model="note.refs"></textarea></td>
        </tr>
      </table>
      <button class="red-button" @click="save()">Save All {{ varieties[var_id] }} Notes</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'WinemakingNotes',
  components: {
  },
  props: ['var_id'],
  watch: {
    var_id: function (newVal, oldVal) {
      this.loadNotes();
    },
  },
  data() {
    return {
      moment,
      varieties: {},
      notes: [],
    };
  },
  mounted() {
    const app = this;
    axios.get('varieties')
      .then((resp) => {
        // console.log(resp.data);
        app.varieties = {};
        resp.data.forEach((variety) => {
          app.varieties[variety.id] = variety.name;
        });
        console.log(app.varieties);
      })
      .catch((resp) => {
        // console.log(resp);
        alert('Problem!');
      });
    this.loadNotes();
  },
  methods: {
    loadNotes() {
      const app = this;
      this.notes = [];
      const levels = ['low', 'med', 'high'];
      levels.forEach((level) => {
        levels.forEach((level2) => {
          this.notes.push({
            var_id: app.var_id,
            skin: level,
            seed: level2,
            aim: '',
            suggestion: '',
            refs: '',
          });
        });
      });
      if (!this.var_id) return;
      axios.get(`winemaking-notes-variety/${app.var_id}`)
        .then((resp) => {
          // console.log(resp.data);
          resp.data.forEach((noteIn) => {
            app.notes.forEach((note, index) => {
              if (noteIn.skin_level === note.skin && noteIn.seed_level === note.seed) {
                app.notes[index].aim = noteIn.aim;
                app.notes[index].suggestion = noteIn.suggestion;
                app.notes[index].refs = noteIn.refs;
              }
            });
          });
          console.log(app.notes);
        })
        .catch((resp) => {
          // console.log(resp);
          alert('Problem!');
        });
    },
    save() {
      const app = this;
      axios({ url: `winemaking-notes-variety/${app.var_id}`, method: 'POST', data: this.notes })
        .then((resp) => {
          // console.log(resp.data);
          alert('The notes have been saved.');
        })
        .catch((resp) => {
          // console.log(resp);
          alert('There was a problem saving the notes.');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/_colors.scss';
  @import '../assets/_globals.scss';
  @import '../assets/_common.scss';


  textarea {
    width: 100%;
    height: 200px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/WinemakingNotes.vue